import { Injectable } from '@angular/core';
import { Observable, throwError, of, Subject, BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { CallBackTransformService } from './call-back-transform.service';
import { EnvService } from './env.service';
import { LocalStorageService } from './local-storage.service';
import { localStorageConstants } from '../localStorageConstants/localStorageConstants';

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireService {
  peopleQuestionnaireData = new Subject<string>();
  public refreshData = new BehaviorSubject<boolean>(false);
  constructor(
    private http: HttpClient,
    private callBackService: CallBackTransformService,
    private envService: EnvService,
    private localStorageService: LocalStorageService
  ) {}

  /**
   * API to get all questionnaires
   * @param searchData : searchobject
   */
  getAllQuestionnaires(searchData: any) {
    const url = this.envService.apiUrl + 'questionnaires';
    return this.http.post<any>(url, searchData).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /**
   * API to get questionnaire details
   * @param id : id
   * @param pageno : page number
   * @param pagesize : page size
   */
  getQuestionnaireDetails(searchParams) {
    const url = this.envService.apiUrl + 'all-questionnaire-Details/';
    return this.http.post<any>(url, searchParams).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  getAllQuestionnaireItems(){
    

  }

  getQuestionnaireCategoryItem(id) {
    const url = this.envService.apiUrl + 'category-item/' + id;
    return this.http.get<any>(url, id).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /**
   * API to get questionnaire notification details
   * @param id : id
   */
  getNotificationDetails(id) {
    const url = this.envService.apiUrl + 'notification-Details/' + id;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  getSkipRules(id) {
    const url = this.envService.apiUrl + 'questionnaire-skip-logic/' + id;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  getDefaultDependantRules(id) {
    const url = this.envService.apiUrl + 'questionnaire-default-response/' + id;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  getSkipRulesForEmail(id) {
    const url =
      this.envService.apiUrl + 'questionnaire-skip-logic-anonymous/' + id;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /**
   * @param params : parameters
   * @returns Observable
   */
  updateQuestionnaireVersion(params): Observable<any> {
    const url = this.envService.apiUrl + 'questionnaire';
    return this.http.put<any>(url, params).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /**
   * Function to get remainder schedule
   */
  getRemainderSchedule(id) {
    const url = this.envService.apiUrl + 'reminder-schedule-Details/' + id;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /**
   * APi to update the question detail row
   */
  updateQuestiondetail(data) {
    const url = this.envService.apiUrl + 'questionnaire-details';
    return this.http.put<any>(url, data).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }
  /**
   * APi to save the clone questionnaire values
   *   * @param questionnaireInfo :  table data object
   */
  cloneQuestionnaire(questionnaireInfo) {
    const url = this.envService.apiUrl + 'questionnaire/' + questionnaireInfo;
    return this.http.post<any>(url, questionnaireInfo).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /**
   * Api for person questionnaire list
   */
  getPersonQuestionnaireList(searchObject) {
    const url =
      this.envService.apiUrl +
      'person-questionnaires'
    return this.http.post<any>(url, searchObject).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /**
   * Api to get person questionnaire category
   */
  getPersonQuestionnaireCategory(id) {
    const url = this.envService.apiUrl + 'questions/' + id;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /**
   * Api to get person questionnaire Default Response
   */
  getPersonQuestionnaireDefaultResponse(personIndex, qid) {
    const url =
      this.envService.apiUrl +
      'questionnaire-default-response-values/' +
      personIndex +
      '/' +
      qid;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /**
   * Api to get person questionnaire values
   * @param  personIndex : person index
   * @param  qid : id
   */
  getPersonQuestionnaireValues(personIndex, qid, assessmentIDs) {
    const params = {
      personIndex: personIndex,
      questionnaireId: qid,
      assessmentIDs: assessmentIDs,
    };
    const url = this.envService.apiUrl + 'assessment-values';
    return this.http.post<any>(url, params).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  getQuestionnaireAssesmentDetails(
    personIndex,
    qid,
    assessmentId,
    pageNumber,
    totalCount
  ) {
    const url =
      this.envService.apiUrl +
      'assessment-details/' +
      personIndex +
      '/' +
      qid +
      '/' +
      assessmentId +
      '/' +
      pageNumber +
      '/' +
      totalCount;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }
  /* APi to update the questionnaire schedule
   */
  updateSchedule(data) {
    const url = this.envService.apiUrl + 'schedule';
    return this.http.put<any>(url, data).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /* APi to retrive questionnaire details for assessements
   */
  assessmentDetails(
    personIndex,
    questionnaireId,
    assessmentId,
    pageNumber,
    totalCount
  ) {
    const url =
      this.envService.apiUrl +
      'assessment-details/' +
      personIndex +
      '/' +
      questionnaireId +
      '/' +
      assessmentId +
      '/' +
      pageNumber +
      '/' +
      totalCount;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  assessmentDetailsDate(
    personIndex,
    questionnaireId,
    assessmentId,
    pageNumber,
    totalCount,
    dateperiod
  ) {
    let url =
      this.envService.apiUrl +
      'assessment-details/' +
      personIndex +
      '/' +
      questionnaireId +
      '/' +
      assessmentId +
      '/' +
      pageNumber +
      '/' +
      totalCount;

    if (!!dateperiod) {
      url = url + '/' + dateperiod;
    }

    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }
  /* APi to retrive person supports
   */
  getPersonSupports(personIndex) {
    const url = this.envService.apiUrl + 'person-supports/' + personIndex;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /**
   * Api for person questionnaire list without collaborations
   * @param searchObject - Object containing searchFilter, personIndex, pageNumber, pageSize
   */
  getPersonQuestionnaireListWithoutCollaboration(
    searchObject: {
      searchFilter: string;
      personIndex: string;
      pageNumber: number;
      pageSize: number;
    }
  ): Observable<any> {
    const url = this.envService.apiUrl + 'questionnaires-data';
    return this.http.post<any>(url, searchObject).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /**
   * API to get all questionnaires with completed status
   * @param personIndex : person index
   * @param pageNumber : page number
   * @param pageSize : page size
   */
  getAllQuestionnairesWithCompletedAssessment(
    personIndex,
    personcollaborationID,
    voiceTypeID,
    voiceTypeFKID,
    pageNumber,
    pageSize
  ): Observable<any> {
    const url =
      this.envService.apiUrl +
      'assessed-questionnaires/' +
      personIndex +
      '/' +
      personcollaborationID +
      '/' +
      voiceTypeID +
      '/' +
      voiceTypeFKID +
      '/' +
      pageNumber +
      '/' +
      pageSize;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }
  /**
   * @param params : parameters
   * @returns Observable
   */
  addQuestionnaireWithoutCollaborations(params): Observable<any> {
    const url = this.envService.apiUrl + 'personQuestionnaire';
    return this.http.post<any>(url, params).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /**
   * @param params : parameters
   * @returns Observable
   */
  deleteAssesmentByAssesId(assesmentID): Observable<any> {
    const url = this.envService.apiUrl + 'remove-assessment/' + assesmentID;
    return this.http.delete<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  setPeopleQuestionnaireData(peopleQuestionnaireData) {
    this.peopleQuestionnaireData.next(peopleQuestionnaireData);
  }

  getPeopleQuestionnaireData(): Observable<string> {
    return this.peopleQuestionnaireData;
  }

  getPersonCollaborations(personIndex, questionnaireID): Observable<any> {
    const url =
      this.envService.apiUrl +
      'person-collaborations/' +
      personIndex +
      '/' +
      questionnaireID;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  deleteQuestionnaire(questionnaireID) {
    const url = this.envService.apiUrl + 'questionnaire/' + questionnaireID;
    return this.http.delete<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  getVoiceTypeByFilter(personIndex, questionnaireID): Observable<any> {
    const url =
      this.envService.apiUrl +
      'voice-type-filters/' +
      personIndex +
      '/' +
      questionnaireID;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  getReminderScheduleLookup(): Observable<any> {
    const url = this.envService.apiUrl + 'regular-reminder-lookups';
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /**API to delete a questionnaire instance
   * @param   personIndex :person index
   * @param   questionnaireID :  id
   */
  deleteQuestionnaireInstance(personIndex, questionnaireID) {
    const url =
      this.envService.apiUrl +
      'person-questionnaire/' +
      personIndex +
      '/' +
      questionnaireID;
    return this.http.delete<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  // API to fetch responseTypeData
  getResponseValueType(): Observable<any> {
    const responseValueTypes = this.localStorageService.getFromLocalStorage(localStorageConstants.responseValueTypes);
    if (responseValueTypes == null || responseValueTypes.length === 0) {
      const url = this.envService.apiUrl + 'response-value-type';
      return this.http.get<any>(url).pipe(
        map((output) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.responseValueTypes,
            JSON.stringify(this.callBackService.transformOutput(output)));
          return this.callBackService.transformOutput(output);
        }),
        catchError((err) => {
          return throwError(this.callBackService.transformOutput(err));
        })
      );
    }else{
      const result = new Observable((observer) => {
        observer.next(responseValueTypes);
      });
      return result;
    }
  }

  // API to fetch reports
  getReportList(instrumentId): Observable<any> {
    const url = this.envService.apiUrl + 'report/powerbi/' + instrumentId;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  // API to fetch responseTypeData
  getPowerBIUrl(param): Observable<any> {
    const url = this.envService.apiUrl + 'report/powerbi-token-url';
    return this.http.post<any>(url, param).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

getScoringDetailsForInviteToComplete(qid) {
  const url = this.envService.apiUrl + 'get-scoring-details-anonymous/' + qid;
  return this.http.get<any>(url).pipe(
    map(output => {
      return this.callBackService.transformOutput(output);
    }),
    catchError(err => {
      return throwError(this.callBackService.transformOutput(err));
    })
  );
}
  getScoringDetails(qid) {
    const url = this.envService.apiUrl + 'get-scoring-details/' + qid;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  getDocuSignLInk(personIndex, assessmentNumber, ItemId) {
    const url =
      this.envService.apiUrl +
      'get-docusign-link/' +
      personIndex +
      '/' +
      assessmentNumber +
      '/' +
      ItemId;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  viewDocument(envelopeId, personIndex) {
    const url =
      this.envService.apiUrl +
      'docusign-sign/' +
      envelopeId +
      '/' +
      personIndex;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  setRefreshFlag(flag) {
    this.refreshData.next(flag);
  }

  /**
   * Api for advanced search person questionnaire list
   * @param searchObject - Object containing searchFilter, personIndex, pageNumber, pageSize
   */
  getAdvancedSearchQuestionnaireList(
    searchObject: {
      searchFilter: string;
      personIndex: string;
      pageNumber: number;
      pageSize: number;
    }
  ): Observable<any> {
    const url = this.envService.apiUrl + 'questionnaires-search-person-data';
    return this.http.post<any>(url, searchObject).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  /**
   * @param params : parameters
   * @returns Observable
   */
  addConsentApproveForQuestionnaire(params): Observable<any> {
    const url = this.envService.apiUrl + 'add-shared-consent';
    return this.http.post<any>(url, params).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  addConsentApproveForQuestionnaireAnonymous(params): Observable<any> {
    const url = this.envService.apiUrl + 'add-shared-consent-anonymous';
    return this.http.post<any>(url, params).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }
  getParedRolePermission(instrumentID,params) {
    const url =
      this.envService.apiUrl +
      'agency-level-praed-instrument-approve/'+ instrumentID;
      params.personAgencyID = this.localStorageService.getDataFromLocalStorage('personAgencyID');
    return this.http.get<any>(url,{params}).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  getRules(params): Observable<any> {
    const url = this.envService.apiUrl + 'rules-engine?questionnaierID=' + params?.questionnaireID + '&personIndex=' + params?.personIndex;
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  validateAgencyReviewerInstrument(instrumentID,params){
    const url = this.envService.apiUrl+'validate-agency-reviewer-instrument/'+instrumentID
    return this.http.get<any>(url,{params}).pipe(
      map((output)=>{
        return this.callBackService.transformOutput(output)
      }),
      catchError((err)=>{
        return throwError(this.callBackService.transformOutput(err))
      })
    )
  }

  getByteArrayFromURL(params): Observable<any> {
    const url = this.envService.apiUrl + 'download-file';
    return this.http.post<any>(url, params).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  showSubmitAndApprove(data, params): Observable<any> {
    const url = this.envService.apiUrl + 'submit-approve-button/'+data.agencyID+'/'+data.instrumentID;
    return this.http.get<any>(url, {params}).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }


  /* APi to retrive autosave configurations
   */
  getAutoSaveConfigurations(personAgencyId) {
    const url = this.envService.apiUrl + 'autosave-configurations/' + personAgencyId;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }

  getReviewerDetails(userId, personIndex, assessmentId) {
    const url = this.envService.apiUrl + 'helper-reviewer-details/' + userId + '/' + personIndex + '/' + assessmentId;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackService.transformOutput(err));
      })
    );
  }
}
